import { reducer as referrals } from "./referrals/slice";

export const reducer = {
  referrals,
};
